<template>
  <va-card :title="$t('tables.comments')" v-if="anyItem">
    <div class="row">
      <div class="flex xs12">
        <div class="row">
          <div class="flex xs12">
            <va-data-table :fields="fields" :data="comments" :per-page="10" hoverable ></va-data-table>
          </div>
        </div>
      </div>
    </div>
  </va-card>
</template>

<script>
export default {
  name: 'timesheet-comments',
  props: {
    entry: Object,
  },
  components: {},
  computed: {
    anyItem () {
      return (
        this.entry !== null &&
        this.entry.comments !== undefined &&
        this.entry.comments.length > 0
      )
    },
    fields () {
      return [
        {
          name: 'formatted_date',
          title: this.$t('tables.commentHeadings.date'),
          width: '20%',
        },
        {
          name: 'detail',
          title: this.$t('tables.commentHeadings.comment'),
          width: '50%',
        },
        {
          name: 'by',
          title: this.$t('tables.commentHeadings.by'),
          width: '25%',
        },
      ]
    },
    comments () {
      if (this.entry.comments !== undefined) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        var records = this.entry.comments.sort((a, b) => {
          if (a.created_at > b.created_at) {
            return -1
          } else if (a.created_at < b.created_at) {
            return 1
          } else {
            return 0
          }
        })
        return records
      } else {
        return []
      }
    },
  },
}
</script>

<style lang="scss">

</style>
